module.exports = __webpack_public_path__ + "img/corto_sx.71ad6fb1.png";